module.exports = __webpack_public_path__ + "media/img/seed/6-55711d046a3e4bdef8b0da758cbaaee8.jpeg";